import React, { useState, createRef } from 'react';
import "./crudbar.scss";
import Title from "../Title";
import search from '../../assets/svg/search.svg';
import close from '../../assets/svg/modal-close.svg';
import add from '../../assets/svg/ic-actions-add-simple.svg';
import { Link } from "react-router-dom";

const CrudBar = ({ title, breadcrumb, noSearch, searchAction, buttonText, buttonAction, linkText, linkTo, style }) => {
    const searchTextRef = createRef();
    const myFormRef = createRef();
    const [txtSearch, setTxtSearch] = useState('');
    let timerToSendSearch = null;

    const resetTimerToSearch = () => {
        try {
            clearInterval(timerToSendSearch);
        } catch { }
        timerToSendSearch = null;
    }

    const sendSearch = (text) => {
        setTxtSearch(text);
        resetTimerToSearch();
        timerToSendSearch = setTimeout(() => {
            if (searchAction) {
                searchAction(text);
            }
        }, 400);
    }

    const limparFiltro = () => {
        setTxtSearch('');
        if (searchAction)
            searchAction('');
    }

    const buttonClick = () => {
        if (buttonAction) {
            buttonAction();
        }
    }
    const submit = (t) => {
        t.preventDefault();
        sendSearch(searchTextRef.current.value)
    }
    return (
        <div className="crudbar" style={style}>
            <Title title={title} breadcrumb={breadcrumb} />
            <form ref={myFormRef} className="actions" onSubmit={submit}>
                {(!noSearch) ? <div className="search" onClick={() => { searchTextRef.current.focus() }}>
                    <input
                        name="search"
                        placeholder="Buscar"
                        ref={searchTextRef}
                        onKeyUp={(e) => { e.preventDefault(); sendSearch(e.target.value) }}
                        className='search-input'
                    />

                    <button type="reset" onClick={() => limparFiltro()}>
                        <img src={(txtSearch.length > 0) ? close : search} height="16" width="16" />
                    </button>
                </div> : null}
                {(linkText) ?
                    <Link to={linkTo} className="gbButton"><img src={add} height={12} style={{ marginRight: 4 }} /> {linkText}</Link> :
                    (buttonText) ? <button className="gbButton" type="button" onClick={buttonClick}><img src={add} height={12} style={{ marginRight: 4 }} /> {buttonText}</button> : null}
            </form>
        </div>
    )

}

export default CrudBar;